module.exports = __webpack_public_path__ + "img/order-empty@2x.67a35e13.png";